// extracted by mini-css-extract-plugin
module.exports = {"policies":"policies___3NvEV","policy":"policy___2MeZV","title":"title___DKrVw","pre":"pre___1CVpl","empty":"empty___1sE1M","block":"block___1Aw6c"};